/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import ImageLoad from "../ImageLoad";
import secureLocalStorage from "react-secure-storage";
import { showToast } from "../../showTost";
import {
  LuStar,
  LuMapPin,
  LuChevronRight,
  LuSearch,
  LuX,
} from "react-icons/lu";
import { IoClose } from "react-icons/io5";

const LabDetails = () => {
  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [sliderImg, setSliderImg] = useState([]);
  const [category, setCategory] = useState([]);

  // Search & Geolocation States
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [bookingLoadingId, setBookingLoadingId] = useState(null);

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  const navigator = useNavigate();

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: true },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: true },
      },
      {
        breakpoint: 770,
        settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false },
      },
    ],
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(String(position.coords.latitude));
          setLongitude(String(position.coords.longitude));
        },
        (error) => {
          console.error(
            "Geolocation error, using fallback Surat coordinates:",
            error,
          );
          setLatitude("21.215814");
          setLongitude("72.828308");
        },
      );
    } else {
      console.warn(
        "Geolocation is not supported by this browser, using fallback Surat coordinates.",
      );
      setLatitude("21.215814");
      setLongitude("72.828308");
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${ApiBaseUrl}/customer/lab_category_list`)
      .then((res) => {
        const { ResponseCode, banner_list, category_list } = res.data;
        if (ResponseCode === 200) {
          setSliderImg(banner_list);
          setCategory(category_list);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  const HandleNavigate = (item) => {
    navigator("/category-details");
    sessionStorage.setItem(
      "Docdetails",
      JSON.stringify({ Categoryid: item.id, title: item.name }),
    );
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();

    setSearchLoading(true);

    const latVal = latitude || "21.215814";
    const lonVal = longitude || "72.828308";
    
    const Userid = secureLocalStorage.getItem("Userid") || "0";

    axios
      .post(`${ApiBaseUrl}/customer/lab-package-search`, {
        user_lat: Number(latVal),
        user_lon: Number(lonVal),
        id: Number(Userid),
        category_id: 0,
        searchtext: searchQuery,
      })
      .then((res) => {
        const { ResponseCode, packages } = res.data;
        if (ResponseCode === 200) {
          setSearchResults(packages || []);
          setHasSearched(true);
        } else {
          showToast({
            title: res.data.message || t("Something went wrong!"),
            id: "error",
          });
        }
        setSearchLoading(false);
      })
      .catch((err) => {
        console.error("API failed. Trying fallback endpoints...", err);
      });
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setSearchResults([]);
    setHasSearched(false);
  };

  // Handle package booking
  const handleBookPackage = (item, e) => {
    if (e) e.stopPropagation();
    const Userid = secureLocalStorage.getItem("Userid");
    if (!Userid) {
      setIsLoginShow(true);
      return;
    }

    setBookingLoadingId(item.id);
    axios
      .post(`${ApiBaseUrl}/customer/add_cart`, {
        id: Userid,
        lab_id: item.lab_id,
        package_id: item.id,
      })
      .then((res) => {
        if (res.data.ResponseCode === 200) {
          showToast({
            title:
              item.exist === 0
                ? t("Package added to cart successfully")
                : t("Package removed from cart successfully"),
            id: "success",
          });
          handleEditPackage(item.id);
        } else {
          showToast({
            title: res.data.message || t("Failed to add to cart"),
            id: "error",
          });
        }
        setBookingLoadingId(null);
      })
      .catch((err) => {
        console.error(err);
        showToast({ title: t("Something went wrong"), id: "error" });
        setBookingLoadingId(null);
      });
  };

  useEffect(() => {
    loading || selectedPackage
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading, selectedPackage]);

  const handleEditPackage = (id) => {
    const EditList = searchResults.map((item) => {
      if (item.id == id) {
        return {...item, exist : item.exist == 1 ? 0 : 1};
      }
      return item;
    });
    setSearchResults(EditList);
  };

  if (loading) {
    return (
      <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
    );
  }

  return (
    <div className="w-full pb-12 width-container px-4 sm:px-6 py-6 md:py-8 bg-slate-50/10">
      {sliderImg.length > 0 && (
        <div className="slider-container mt-2 mb-8 rounded-2xl overflow-hidden shadow-sm p-1 bg-white border border-slate-100/50">
          <Slider {...settings}>
            {sliderImg.map((item, index) => (
              <div key={index} className="px-1.5">
                <div className="h-[200px] sm:h-[220px] rounded-xl overflow-hidden border border-slate-100">
                  <ImageLoad
                    src={ImgBaseUrl + item}
                    CustomeStyle="h-full w-full object-cover"
                    alt="Lab Banner"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}

      <div className="w-full bg-white border border-slate-150 rounded-3xl p-5 sm:p-6 mb-8 shadow-sm">
        <h2 className="text-lg font-bold text-slate-800 mb-4">
          {t("Search Test Packages")}
        </h2>

        <form
          onSubmit={handleSearch}
          className="flex flex-col sm:flex-row gap-3"
        >
          <div className="relative flex-1">
            <LuSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={t(
                "Search by package title, tests (e.g. Thyroid)...",
              )}
              className="w-full bg-slate-50 border border-slate-200/80 rounded-2xl py-3.5 pl-12 pr-10 text-sm font-medium text-slate-800 focus:outline-none focus:border-indigo-500 focus:bg-white transition-all duration-200"
            />
            {searchQuery && (
              <button
                type="button"
                onClick={handleClearSearch}
                className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-200/50 transition-colors"
              >
                <LuX className="w-4 h-4" />
              </button>
            )}
          </div>
          <button
            type="submit"
            disabled={searchLoading}
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-sm px-8 py-3.5 rounded-2xl transition-all duration-200 shadow-sm hover:shadow active:scale-95 flex items-center justify-center gap-2"
          >
            {searchLoading ? (
              <svg
                className="w-4 h-4 animate-spin shrink-0"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                />
              </svg>
            ) : (
              <span>{t("Search")}</span>
            )}
          </button>
        </form>
      </div>

      {hasSearched ? (
        <div className="space-y-6">
          <div className="border-b border-slate-100 pb-3 flex items-center justify-between">
            <div>
              <h2 className="text-xl sm:text-2xl font-extrabold text-slate-800 tracking-tight">
                {t("Packages Found")}
              </h2>
              <p className="text-xs sm:text-sm text-slate-400 font-medium mt-1">
                {t("Search results for")}:{" "}
                <span className="font-semibold text-indigo-650">
                  "{searchQuery || t("All")}"
                </span>
              </p>
            </div>
            <button
              onClick={handleClearSearch}
              className="text-xs font-bold text-indigo-600 bg-indigo-50 px-4 py-2 rounded-full border border-indigo-100 hover:bg-indigo-100 transition-all cursor-pointer flex items-center gap-1"
            >
              <span>&larr; {t("Back to Categories")}</span>
            </button>
          </div>

          {searchLoading ? (
            <div className="flex items-center justify-center py-20">
              <div className="loader2"></div>
            </div>
          ) : searchResults.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {searchResults.map((item, index) => {
                const isLoading = bookingLoadingId === item.id;
                const totalPrice = Array.isArray(item.package_price)
                  ? item.package_price.reduce((a, b) => a + b, 0)
                  : item.package_price;
                return (
                  <div
                    onClick={() => setSelectedPackage(item)}
                    key={index}
                    className="group bg-white rounded-3xl border border-slate-150 hover:border-indigo-500/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-300 flex flex-col justify-between"
                  >
                    <div className="bg-slate-50/80 px-4 py-2 border-b border-slate-100/60 flex items-center justify-between gap-2">
                      <div className="flex items-center gap-2 overflow-hidden">
                        {item.lab_logo && (
                          <ImageLoad
                            src={ImgBaseUrl + item.lab_logo}
                            CustomeStyle="h-6 w-6 object-contain rounded-full border border-slate-200"
                            alt={item.lab_name}
                          />
                        )}
                        <span className="text-[11px] font-bold text-slate-500 truncate">
                          {item.lab_name}
                        </span>
                      </div>
                      <div className="flex items-center gap-0.5 text-slate-500 text-[10px] font-semibold shrink-0">
                        <LuMapPin className="w-3 h-3 text-indigo-500" />
                        <span>{item.distance} km</span>
                      </div>
                    </div>

                    <div className="relative h-36 bg-slate-50/50 p-4 flex items-center justify-center border-b border-slate-100">
                      <ImageLoad
                        src={ImgBaseUrl + item.logo}
                        CustomeStyle="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-105"
                        alt={item.title}
                      />
                    </div>

                    <div className="p-5 flex-1 flex flex-col justify-between">
                      <div>
                        <h3 className="font-bold text-slate-800 text-base group-hover:text-indigo-650 transition-colors duration-200 line-clamp-1 w-full mb-1">
                          {item.title}
                        </h3>
                        <p className="text-slate-500 text-xs line-clamp-2 mb-3 leading-relaxed">
                          {item.subtitle}
                        </p>
                        <span className="text-indigo-600 bg-indigo-50 border border-indigo-100 rounded-full px-3 py-1 text-[11px] font-bold inline-block mb-4">
                          {t("Includes")} {item.package_name?.length || 0}{" "}
                          {t("tests")}
                        </span>
                      </div>

                      <div>
                        <div className="flex items-center justify-between mb-4 gap-2">
                          <span className="text-slate-900 font-extrabold text-xl">
                            {currency} {totalPrice}
                          </span>
                          <div className="flex items-center">
                            {isLoading ? (
                              <div className="py-2 px-5 bg-slate-100 border border-slate-200 rounded-xl flex items-center justify-center">
                                <span className="loader2"></span>
                              </div>
                            ) : (
                              <button
                                onClick={(e) => handleBookPackage(item, e)}
                                className={`py-2.5 px-6 rounded-xl font-semibold text-sm transition-all duration-200 active:scale-95 ${item.exist === 0 ? "bg-indigo-600 hover:bg-indigo-700 text-white" : "bg-rose-50 hover:bg-rose-100 border border-rose-200 text-rose-600"}`}
                              >
                                {item.exist === 0 ? t("Book") : t("Remove")}
                              </button>
                            )}
                          </div>
                        </div>

                        <div className="text-slate-400 flex items-center justify-between border-t border-slate-100 pt-3 text-[10px] font-semibold">
                          <div className="flex items-center gap-1">
                            <span className="w-1.5 h-1.5 bg-slate-300 rounded-full"></span>
                            <span>{item.fasting_require}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <span className="w-1.5 h-1.5 bg-slate-300 rounded-full"></span>
                            <span>
                              {t("Reports in")} {item.test_report_time}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="col-span-full bg-slate-50 rounded-3xl p-12 flex flex-col items-center justify-center text-center border border-dashed border-slate-200">
              <div className="w-16 h-16 bg-slate-200/50 rounded-full flex items-center justify-center text-slate-400 mb-4">
                <LuSearch className="w-8 h-8" />
              </div>
              <h3 className="font-bold text-slate-800 text-lg">
                {t("No Results Found")}
              </h3>
              <p className="text-slate-500 text-sm max-w-sm mt-1">
                {t(
                  "We couldn't find any match for your search query. Please try searching with a different term.",
                )}
              </p>
              <button
                onClick={handleClearSearch}
                className="mt-5 px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-bold transition-all shadow-sm active:scale-95"
              >
                {t("Clear Search")}
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="space-y-6">
          <div className="border-b border-slate-100 pb-3 flex items-center justify-between">
            <div>
              <h1 className="text-xl sm:text-2xl font-extrabold text-slate-800 tracking-tight">
                {t("Lab Category")}
              </h1>
              <p className="text-xs sm:text-sm text-slate-400 font-medium mt-1">
                {t("Select a category to view available tests & packages")}
              </p>
            </div>
            <span className="text-xs font-bold text-indigo-650 bg-indigo-50/60 px-3 py-1 rounded-full border border-indigo-100/20">
              {category.length} {t("Categories")}
            </span>
          </div>

          {/* Highly responsive columns matched to Shop design */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-5 mt-6">
            {category.map((item, index) => (
              <div
                onClick={() => HandleNavigate(item)}
                key={index}
                className="group bg-white rounded-2xl border border-slate-150 hover:border-indigo-500/30 cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-350 p-5 flex flex-col justify-center items-center text-center relative overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-b from-indigo-50/0 to-indigo-50/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-slate-50 group-hover:bg-indigo-50/80 flex items-center justify-center p-3 mb-4 transition-all duration-300 relative z-10">
                  <ImageLoad
                    src={ImgBaseUrl + item.image}
                    CustomeStyle="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                    alt={item.name}
                  />
                </div>
                <h3 className="font-semibold text-slate-800 text-sm md:text-base group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 w-full relative z-10">
                  {item.name}
                </h3>
                <span className="text-[11px] font-medium text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-full mt-2.5 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-1 group-hover:translate-y-0 relative z-10 flex items-center gap-0.5">
                  {t("Explore")}{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="inline-block shrink-0"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Package Details Modal */}
      {selectedPackage && (
        <div
          onClick={() => setSelectedPackage(null)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in animate-duration-200"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col p-6 relative overflow-hidden mx-4"
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedPackage(null)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close modal"
            >
              <IoClose className="w-6 h-6" />
            </button>

            <div className="flex-1 overflow-y-auto scroll-container pr-1 mt-2">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 pb-4 border-b border-slate-100">
                <div className="relative group overflow-hidden rounded-2xl border border-slate-200/60 bg-white p-1 shrink-0">
                  <ImageLoad
                    src={ImgBaseUrl + selectedPackage.logo}
                    CustomeStyle="h-[80px] w-[80px] object-contain rounded-xl"
                    alt={selectedPackage.title}
                  />
                </div>
                <div className="leading-snug">
                  <h2 className="font-bold text-slate-800 text-xl">
                    {selectedPackage.title}
                  </h2>
                  <p className="text-slate-500 text-sm mt-1">
                    {selectedPackage.subtitle}
                  </p>
                </div>
              </div>

              {/* Features grid section */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 flex items-center gap-3">
                  <svg
                    width="26"
                    height="26"
                    className="text-slate-700"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 17.9668V10.1503C21 8.93937 20.4604 7.7925 19.5301 7.02652L14.5301 2.90935C13.0577 1.69688 10.9423 1.69689 9.46986 2.90935L4.46986 7.02652C3.53964 7.7925 3 8.93937 3 10.1503V17.9668C3 20.1943 4.79086 22 7 22H17C19.2091 22 21 20.1943 21 17.9668Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10 18H14"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>

                  <div>
                    <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">
                      {t("Home Collect Extra Price")}
                    </span>
                    <span className="text-slate-700 font-bold text-base">
                      {currency} {selectedPackage.home_extra_price}
                    </span>
                  </div>
                </div>

                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 flex items-center gap-3">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    className="text-slate-700"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.53 20.47C21.823 20.763 21.823 21.238 21.53 21.531C21.384 21.677 21.192 21.751 21 21.751C20.808 21.751 20.616 21.678 20.47 21.531L15 16.061L12.88 18.1811C12.647 18.4151 12.334 18.5431 12 18.5431C11.666 18.5431 11.353 18.414 11.119 18.18L9.96999 17.0301C9.67699 16.7371 9.67699 16.262 9.96999 15.969C10.263 15.676 10.738 15.676 11.031 15.969L12.001 16.939L14.471 14.469C14.763 14.177 15.234 14.177 15.527 14.466L15.528 14.4651L15.531 14.468L15.537 14.474L21.53 20.47ZM6.96999 14.0301C7.11599 14.1761 7.30799 14.25 7.49999 14.25C7.69199 14.25 7.88399 14.1771 8.02999 14.0301C8.32299 13.7371 8.32299 13.262 8.02999 12.969L7.35998 12.299C5.94498 10.884 4.74999 7.99905 4.74999 5.99905V5.81002L8.479 9.54C8.625 9.686 8.817 9.76003 9.009 9.76003C9.201 9.76003 9.39299 9.687 9.53899 9.54C9.83199 9.247 9.83199 8.77203 9.53899 8.47903L4.52898 3.46902C4.45998 3.40002 4.377 3.34503 4.285 3.30703C4.102 3.23103 3.895 3.23103 3.712 3.30703C3.529 3.38303 3.38199 3.52904 3.30599 3.71304C3.26799 3.80504 3.24798 3.90202 3.24798 4.00002V6.00002C3.24798 8.41702 4.588 11.65 6.298 13.36L6.96999 14.0301ZM15.5 12.783C16.597 12.783 17.695 12.3651 18.53 11.5301L21.53 8.53005C21.823 8.23705 21.823 7.76202 21.53 7.46902C21.237 7.17602 20.762 7.17602 20.469 7.46902L17.469 10.469C16.383 11.555 14.615 11.555 13.53 10.469C13.004 9.94302 12.714 9.24305 12.714 8.49905C12.714 7.75505 13.004 7.05502 13.53 6.52902L16.53 3.52902C16.823 3.23602 16.823 2.76104 16.53 2.46804C16.237 2.17504 15.762 2.17504 15.469 2.46804L12.469 5.46804C11.659 6.27704 11.214 7.35301 11.214 8.49801C11.214 9.38801 11.49 10.232 11.991 10.946L2.46999 20.467C2.17699 20.76 2.17699 21.235 2.46999 21.528C2.61599 21.674 2.80799 21.748 2.99999 21.748C3.19199 21.748 3.38399 21.675 3.52999 21.528L13.053 12.005C13.787 12.519 14.641 12.783 15.5 12.783ZM14.351 8.16103C14.497 8.30703 14.689 8.38003 14.88 8.38003C15.072 8.38003 15.265 8.307 15.411 8.16L18.281 5.28005C18.573 4.98705 18.573 4.51202 18.279 4.21902C17.986 3.92702 17.51 3.92703 17.218 4.22103L14.348 7.10104C14.056 7.39404 14.057 7.86903 14.351 8.16103ZM15.851 9.66103C15.997 9.80703 16.189 9.88003 16.38 9.88003C16.572 9.88003 16.765 9.807 16.911 9.66L19.781 6.78005C20.073 6.48705 20.073 6.01202 19.779 5.71902C19.486 5.42702 19.01 5.42703 18.718 5.72103L15.848 8.60104C15.556 8.89404 15.557 9.36903 15.851 9.66103Z"
                      fill="currentColor"
                    />
                  </svg>

                  <div>
                    <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">
                      {t("Fasting Required")}
                    </span>
                    <span className="text-slate-700 font-bold text-base">
                      {selectedPackage.fasting_require}
                    </span>
                  </div>
                </div>

                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 flex items-center gap-3">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    className="text-slate-700"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z"
                      fill="currentColor"
                    />
                  </svg>

                  <div>
                    <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">
                      {t("Test Report Time")}
                    </span>
                    <span className="text-slate-700 font-bold text-base">
                      {selectedPackage.test_report_time}
                    </span>
                  </div>
                </div>

                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 flex items-center gap-3">
                  <svg
                    width="28"
                    height="28"
                    className="text-slate-700"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.8887 6.1416L17.8583 11.1113L8.74728 20.2223C7.37494 21.5947 5.14995 21.5947 3.77761 20.2223C2.40528 18.85 2.40527 16.625 3.77761 15.2527L12.8887 6.1416Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M17.03 3.65656C17.9449 2.74167 19.4282 2.74167 20.3431 3.65656C21.258 4.57145 21.258 6.05478 20.3431 6.96967L19.5148 7.79795L16.2017 4.48483L17.03 3.65656Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M12.4744 3.24242C13.1605 2.55625 14.273 2.55625 14.9592 3.24242L20.7572 9.04036C21.4433 9.72653 21.4433 10.839 20.7572 11.5252C20.071 12.2114 18.9585 12.2114 18.2723 11.5252L12.4744 5.72725C11.7882 5.04108 11.7882 3.92859 12.4744 3.24242Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M6 13L15 14"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <div>
                    <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block mb-1">
                      {t("Sample Type")}
                    </span>
                    <div className="flex flex-wrap items-center gap-1.5">
                      {selectedPackage.sample_type?.map((item, index) => (
                        <span
                          key={index}
                          className="bg-indigo-50 text-indigo-750 text-xs font-medium px-2 py-0.5 rounded border border-indigo-100"
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Package Includes Tests list */}
              <div className="mt-6 bg-slate-50/50 border border-slate-100 rounded-2xl p-5">
                <div className="flex items-center justify-between pb-3 border-b border-slate-100 mb-4">
                  <div className="flex items-center gap-2">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      className="text-slate-800"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.287 6.88198C21.286 6.87998 21.287 6.878 21.286 6.876C21.284 6.871 21.279 6.868 21.277 6.863C20.89 6.16 20.287 5.57999 19.525 5.24099L13.525 2.574C12.556 2.144 11.447 2.144 10.478 2.574L4.47803 5.24099C3.71503 5.57999 3.11295 6.16 2.72595 6.863C2.72395 6.868 2.71904 6.871 2.71704 6.876C2.71604 6.878 2.71694 6.87998 2.71594 6.88198C2.42294 7.42098 2.25305 8.02898 2.25305 8.66698V15.334C2.25305 16.814 3.12698 18.159 4.47998 18.761L10.48 21.428C10.962 21.642 11.479 21.748 11.996 21.75C11.999 21.751 12.001 21.751 12.004 21.751C12.007 21.751 12.009 21.75 12.012 21.75C12.529 21.749 13.046 21.642 13.528 21.428L19.528 18.761C20.881 18.16 21.755 16.815 21.755 15.334V8.66698C21.75 8.02898 21.58 7.41998 21.287 6.88198ZM11.0861 3.94399C11.3761 3.81499 11.689 3.74999 12 3.74999C12.311 3.74999 12.6239 3.81398 12.9139 3.94298L18.9139 6.60998C19.0839 6.68598 19.233 6.791 19.376 6.902L16.6429 8.11699L9.38403 4.7L11.0861 3.94399ZM7.573 5.505L14.832 8.92199L12.92 9.77199C12.334 10.027 11.663 10.027 11.085 9.77398L4.62402 6.902C4.76702 6.791 4.91606 6.68498 5.08606 6.60998L7.573 5.505ZM5.08606 17.389C4.27406 17.028 3.75 16.221 3.75 15.333V8.66598C3.75 8.50098 3.78595 8.343 3.81995 8.187L10.48 11.147C10.729 11.255 10.987 11.334 11.25 11.386V20.108C11.196 20.089 11.1391 20.078 11.0861 20.055L5.08606 17.389ZM20.25 15.333C20.25 16.221 19.7259 17.028 18.9139 17.389L12.9139 20.056C12.8609 20.08 12.804 20.09 12.75 20.109V11.386C13.014 11.333 13.274 11.254 13.524 11.145L15.879 10.098V11.89C15.879 12.304 16.215 12.64 16.629 12.64C17.043 12.64 17.379 12.304 17.379 11.89V9.432L20.179 8.18798C20.214 8.34498 20.249 8.50198 20.249 8.66698V15.333H20.25Z"
                        fill="currentColor"
                      />
                    </svg>

                    <h3 className="font-bold text-slate-800">
                      {t("Package Includes")}
                    </h3>
                  </div>
                  <span className="font-bold text-indigo-600 text-lg">
                    {currency}{" "}
                    {Array.isArray(selectedPackage.package_price)
                      ? selectedPackage.package_price.reduce((a, b) => a + b, 0)
                      : selectedPackage.package_price}
                  </span>
                </div>

                <div className="space-y-3 max-h-[160px] overflow-y-auto pr-2 scroll-container">
                  {selectedPackage.package_name?.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between text-sm"
                    >
                      <span className="text-slate-600 font-medium">{item}</span>
                      <span className="text-slate-800 font-semibold">
                        {currency} {selectedPackage.package_price?.[index]}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-6">
                <div className="flex items-center gap-2 mb-2">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    className="text-slate-800"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17 21.75H7C4.582 21.75 3.25 20.418 3.25 18V6C3.25 3.582 4.582 2.25 7 2.25H17C19.418 2.25 20.75 3.582 20.75 6V18C20.75 20.418 19.418 21.75 17 21.75ZM7 3.75C5.423 3.75 4.75 4.423 4.75 6V18C4.75 19.577 5.423 20.25 7 20.25H17C18.577 20.25 19.25 19.577 19.25 18V6C19.25 4.423 18.577 3.75 17 3.75H7ZM16.75 12C16.75 11.586 16.414 11.25 16 11.25H8C7.586 11.25 7.25 11.586 7.25 12C7.25 12.414 7.586 12.75 8 12.75H16C16.414 12.75 16.75 12.414 16.75 12ZM13.75 16C13.75 15.586 13.414 15.25 13 15.25H8C7.586 15.25 7.25 15.586 7.25 16C7.25 16.414 7.586 16.75 8 16.75H13C13.414 16.75 13.75 16.414 13.75 16ZM16.75 8C16.75 7.586 16.414 7.25 16 7.25H8C7.586 7.25 7.25 7.586 7.25 8C7.25 8.414 7.586 8.75 8 8.75H16C16.414 8.75 16.75 8.414 16.75 8Z"
                      fill="currentColor"
                    />
                  </svg>

                  <h3 className="font-bold text-slate-800 text-sm tracking-wider uppercase">
                    {t("Package Description")}
                  </h3>
                </div>
                <p className="text-slate-500 text-sm leading-relaxed bg-slate-50 border border-slate-100 p-4 rounded-2xl">
                  {selectedPackage.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LabDetails;
/* jshint ignore:end */
